import {Interaction as InteractionType} from "@/types/interaction";
import React from "react";



interface TextInputType extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {

}
export default function TextInput(props: TextInputType)
{
  return <input type={"text"} {...props} />
}
